import { Injectable, Inject } from '@angular/core';
import { formatDate, parseDate } from "devextreme/localization";
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { IndexGroupsVM, IndexVM } from '../shared/viewmodels/ISearchServiceReg';

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}


@Injectable()
export class UnindexSearchService {
  myAppUrl: string = "";

  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;


  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next("");
        observer.complete();
      } else {
        let reader = new FileReader();
        reader.onload = event => {
          observer.next((<any>event.target).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
  throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
      return _observableThrow(result);
    else
      return _observableThrow(new SwaggerException(message, status, response, headers, null));
  }


  GetIndexMajorIndexGroup(datetabindex:number, roletype:number) {
    console.log('getDocPlanImgByBP');
    return this._http.get<IndexGroupsVM[]>(this.myAppUrl + 'api/ES/GetIndexMajorIndexGroup?pFirst=' + datetabindex + '&pGroup=' + roletype);
  }

  GetUnindexedSearchResults(lname: string, fname:string, range:number) {
    console.log('getDocPlanImgByBP');
    return this._http.get<IndexVM[]>(this.myAppUrl + 'api/ES/GetUnindexedSearchResults?lname=' + lname + '&fname=' + fname + '&range=' + range);
  }

  GetIndexPaths(indexBook: string, indexGroup: string, indexPage: string, dateGroup: number) {
    console.log('GetIndexPaths');
    return this._http.get<string[]>(this.myAppUrl + 'api/ES/GetIndexDirectoryImage?indexBook=' + indexBook + '&indexGroup=' + indexGroup + '&indexPage=' + indexPage + '&dateGroup=' + dateGroup);
  }

  GetUnIndexPaths(Book: string, Page: string, indexId: string ) {
    console.log('GetUnIndexPaths');
    return this._http.get<string[]>(this.myAppUrl + 'api/CoreData/GetUnIndexedImagePaths?Book=' + Book + '&Page=' + Page + '&indexId=' + indexId );
  }


  GetIndexBPImagePath(book: string, stype: string) {
    console.log('GetIndexDirectoryImage');
    return this._http.get<string[]>(this.myAppUrl + 'api/ES/GetIndexBPImagePath?book=' + book + '&stype=' + stype);
  }

  GetDocPlanPage(path: string, page: number) {
    console.log('getDocPlanImgByBP');

    return this._http.get(this.myAppUrl + 'api/ES/GetDocPlanPage?path=' + path + '&page=' + page, { responseType: 'text' });
  }

  logError(message: string) {
    this._http.get<string>(this.myAppUrl + 'api/ES/LogError?message=' + message);
  }

  logInfo(message: string) {
    this._http.get(this.myAppUrl + 'api/ES/LogInfo?message=' + message);
  }

  logWarning(message: string) {
    this._http.get<string>(this.myAppUrl + 'api/ES/LogWarning?message=' + message);
  }
}
